
import React from 'react';

const Home = () => {
  return (
    <div>
      {/* Banner is rendered by Header when no category is active */}
      {/* <GroceriesBannerSlider /> */}
    </div>
  );
};

export default Home;